<template>
  <div class="wrap">
    <myHead nav="3"></myHead>
    <div class="main-content flex-sb">
        <!-- <conMenu></conMenu> -->
        <div class="content main">
          <div class="main-head">
            <i class="el-icon-menu"></i>
            法律法规
          </div>
          <div v-if="!show_detail" class="section-one">
            <ul class="content-list">
              <li v-for="(item,index) in project.list" :key="index">
                <a :title="item.name" href="javascript:;" @click="showDetail(item.id)">
                  <span class="title">{{item.name}}</span>
                </a>
              </li>
            </ul>
            <div class="page-bar fr">
              <el-pagination prev-text="上一页" next-text="下一页" background layout="prev, pager, next" :page-size="project.page.limit" :total="project.page.total" @current-change="handleCurrentChange">
              </el-pagination>
            </div>
          </div>
          <conDetail v-if="show_detail" :detail="detail" :prev="prev" :next="next" @showDetail="showDetail"></conDetail>
        </div>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<!-- 法律法规 -->
<script>
  import Vue from 'vue';
  import myHead from '../../components/myHead/myhead';
  import myFoot from '../../components/myFoot/myfoot';
  import conMenu from '../../components/conMenu/conmenu';
  import conDetail from '../../components/conDetail/condetail';
  import common from '../../assets/js/utils/common';
  import {
    mapActions,
    mapState,
    mapMutations
  } from "vuex";
  
  export default {
    name: "regulation",
    components: {
      myHead,
      myFoot,
      conMenu,
      conDetail
    },
    data() {
      return {
        project: {
          page: {
            limit: 7,
            total: 0,
            pages: 1,
            current: 1
          },
          list: []
        },
				id:0,
        is_loading: false,
        show_detail: false,
        detail:{},
        next:{},
        prev:{},
      }
    },
    mounted() {
			let s_type = this.$route.query.s_type
			let id = this.$route.query.id
			if(s_type){
			  this.s_type = parseInt(s_type)
			}
			if(id){
			  this.id = parseInt(id)
			}
		},
    computed: {

    },
    created() {
      this.getProjectList()
    },
    watch: {
      id(val){
        if(val){
          this.showDetail(val)
        }
      }
    },
    methods: {
      ...mapActions({
        getProjectLawIndex: "index/getProjectLawIndex",
        getProjectLawDetail: "index/getProjectLawDetail",
      }),
      getProjectList(){
        this.getProjectLawIndex({
          data:{
            page:this.project.page.current
          },
          success:(res) => {
            if(res.code == 1){
              this.project = res.data
            }
          },
        })
      },
      handleCurrentChange(current){
        this.project.page.current = current
        this.getProjectList()
      },
      showDetail(id){
        var param = {id:id}
        if(this.is_loading) return
        this.is_loading = true
        this.show_detail = true
        this.getProjectLawDetail({data:param,success:(res) => {
          this.is_loading = false
          if(res.code == 1){
            this.detail = res.data.detail
            this.prev = res.data.prev.id?res.data.prev:{}
            this.next = res.data.next.id?res.data.next:{}
          }
        }})
      },
    }
  }
</script>

<style scoped>
  .main-content {
    position: relative;
    margin-top: 30px;
    display: flex;
    justify-content: space-between;
    margin: 30px auto 0;
    width: 1200px;
  }
  
  .main-content .main {
    width: 1200px;
    background: #fff;
  }

  .main-head {
      text-align: left;
      position: relative;
      padding: 0 20px;
      font-size: 20px;
      font-weight: 700;
      background: #f5fafc;
      color: #0080FF;
      height: 72px;
      line-height: 72px;
    }

    .main-head::before {
     /* content: '';
      position: relative;
      top: 3px;
      display: inline-block;
      width: 20px;
      height: 20px; */
      /* background: #4370ff; */
      /* background: url(../../assets/images/title-before.png); */
    }

  .main-content .main .section-one {
    padding: 16px 2px;
  }

  .main-content .main .section-one .content-list {
    min-height: 300px;
  }

  .main-content .main .section-one .content-list li {
    display: block;
    font-weight: 700;
    padding: 0 20px;
    border-bottom: 1px dashed rgba(0, 0, 0, .2);
  }

  .main-content .main .section-one .content-list li>a {
    display: inline-block;
    width: 100%;
    line-height: 55px;
    position: relative;
  }

  .main-content .main .section-one .content-list li>a:hover {
    color: #0080FF;
  }

  .main-content .main .section-one .content-list li .title {
    width: 100%;
    display: block;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  .main-content .main .section-one .content-list li .time {
    position: absolute;
    width: 15%;
    top: 0;
    right: 0;
  }

  .main-content .main .section-one .page-bar {
    position: relative;
    margin: 20px 0 20px;
    height: 32px;
  }

  /deep/.el-pagination button,
  .el-pagination span:not([class*=suffix]) {
    padding: 0 6px !important;
  }

  /deep/.el-pagination button:hover,
  .el-pagination span:hover {
    color: #c74444 !important;
  }
  /deep/.el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #0080FF;
  }
</style>
